import { Component } from '@angular/core';

declare const MW: any;
declare const BABYLON: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app1',
  templateUrl: './app1.component.html'
})
export class App1Component {
  data = {};

  ngOnInit() {
    var scene = setupScene("canvas1");
    var data = {};

    var textPlane = new BABYLON.Mesh.CreatePlane("planeForText", 20, scene);
    var advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateForMesh(textPlane, 2048, 2048);

    var text = new BABYLON.GUI.TextBlock();
    text.fontSize = 200;
    text.outlineWidth = 5;

    new MW.TwoWayMap({
        end1: data,
        map1: MAP.TEXT.to3DModel,
        end2: text,
        map2: MAP.TEXT.toDataModel,
        data1: {
            text: 'Hello world!',
            diffuseColor: '#dd3300',
            outlineColor: '#ee9966',
        }
    });

    advancedTexture.addControl(text);
    this.data = data;
  }
}